import Keycloak from "keycloak-js";

let keycloakInstance = null;

export const getKeycloakInstance = () => {
    if (!keycloakInstance) {
        keycloakInstance = new Keycloak({
            url: "https://keycloak.diatomic.uk",
            realm: "Canvas",
            clientId: "canvas_react",
        });
    }
    return keycloakInstance;
};
